/**
 * SCSpro 브랜드 / UI 공통 색상·버튼 프리셋
 * - 포인트: PANTONE 871 C (#857651)
 * - 메뉴 배경: PANTONE Black 6 C (#101820)
 */

export const brand = {
  /** PANTONE 871 C — 등록·저장·주요 확정 */
  accent: "#857651",
  accentHover: "#6f6244",
  accentSoft: "rgba(133, 118, 81, 0.12)",
  accentText: "#ffffff",

  /** PANTONE Black 6 C */
  black: "#101820",

  /** 검색·목록 필터 실행 */
  search: "#5B7C8A",
  searchHover: "#4a6773",
  searchText: "#ffffff",

  /** 보조 도구(아이콘 등) */
  tool: "#8FC0CF",

  rowHover: "#f0f4fa", // 단말기 관리 목록 hover 기준
  ink: "#141414",
} as const;

/** @deprecated brand.rowHover — 단말기 관리와 동일 #f0f4fa */
export const ROW_HOVER_BG = brand.rowHover;

/** @deprecated brand.ink */
export const BUTTON_WORD = brand.ink;

/**
 * 공통 UI 용어 (사용자에게 보이는 문구 기준)
 *
 * | 용어 | 사용 | 사용 금지 예 |
 * |------|------|-------------|
 * | 검색 | 조건으로 목록·대상을 찾는 버튼/결과 메시지 | 다이얼로그 OK 버튼 |
 * | 확인 | 알림 닫기, 예/아니오, 삭제 전 검증, 등록 최종 확인 | 검색 버튼 |
 * | 읽기 | 권한 표의 is_read (메뉴 열람) | — |
 * | 쓰기 | 권한 표의 is_write | — |
 * | 등록/수정/삭제 | CRUD 액션 | — |
 * | 승인/반려 | 작업자 승인 흐름 | — |
 * | 취소 | 모달 닫기·작업 중단 | — |
 * | 새로고침 | 목록 재로드(조건 유지) | — |
 *
 * ※ "조회" 는 사용자 버튼에 쓰지 않음. (과거 검색 혼용 방지)
 * ※ "비밀번호 확인" 등 입력 필드는 예외.
 */
export const labels = {
  workEnvironment: "작업 환경",
  workEnvironmentRequired: "작업 환경을 선택하세요.",
  workEnvironmentSelect: "작업 환경 선택",
  register: "등록",
  edit: "수정",
  delete: "삭제",
  search: "검색",
  confirm: "확인",
  cancel: "취소",
  approve: "승인",
  reject: "반려",
  refresh: "새로고침",
  read: "읽기",
  write: "쓰기",
  advancedSearchOpen: "고급검색",
  advancedSearchClose: "고급검색 닫기",
  searchFailed: "검색에 실패하였습니다.",
  searchStart: "검색 시작",
  searchEnd: "검색 종료",
} as const;

/** 목록·모달 액션 버튼 공통 외형 */
export const actionButtonBase = {
  radius: "sm" as const,
  size: "sm" as const,
};

/** 등록 — 기존 연파란 그라데이션 */
export const primaryActionProps = {
  variant: "gradient" as const,
  gradient: { from: "#e0eafc", to: "#b6e0fe", deg: 180 },
  c: "#141414",
  ...actionButtonBase,
};

/** 수정 — 등록과 동일 스타일 */
export const secondaryActionProps = {
  variant: "gradient" as const,
  gradient: { from: "#e0eafc", to: "#b6e0fe", deg: 180 },
  c: "#141414",
  ...actionButtonBase,
};

/** 검색 */
export const searchActionProps = {
  variant: "filled" as const,
  ...actionButtonBase,
  style: {
    backgroundColor: brand.search,
    color: brand.searchText,
    border: "none",
  },
};

/** 삭제·반려 */
export const dangerActionProps = {
  variant: "filled" as const,
  color: "red" as const,
  ...actionButtonBase,
};

/** 취소 */
export const cancelActionProps = {
  variant: "default" as const,
  ...actionButtonBase,
};

/** 새로고침 등 보조 */
export const neutralActionProps = {
  variant: "default" as const,
  ...actionButtonBase,
};

/** 모달 하단 fullWidth 등록·수정 */
export const formPrimaryActionProps = {
  ...primaryActionProps,
  size: "lg" as const,
};

/** 모드 선택 ON (등록 등) */
export const modeOnProps = {
  variant: "filled" as const,
  size: "sm" as const,
  radius: "sm" as const,
  style: {
    backgroundColor: brand.accent,
    color: brand.accentText,
    border: "none",
  },
};

/** 모드 선택 OFF */
export const modeOffProps = {
  variant: "outline" as const,
  size: "sm" as const,
  radius: "sm" as const,
  style: {
    borderColor: brand.accent,
    color: brand.accent,
    backgroundColor: "transparent",
  },
};

/**
 * 단말기 별칭(Alias) 기능 UI 노출 여부
 * - false: 등록 입력창, 테이블 열 등 별칭 관련 UI 전체 숨김 (기본값 '' 처리)
 * - true: 별칭 기능 활성화 (UI 전체 노출)
 */
export const SHOW_ALIAS = false;

